import React from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';

const NavDropdown: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({
  label,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const nodeRef = React.useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  React.useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const toggle = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  React.useEffect(() => {
    const handleClick = (e: Event) => {
      if (nodeRef?.current?.contains(e.target as Node)) {
        return;
      }

      if (isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isOpen]);

  return (
    <div
      className={classnames('px-2', isOpen ? ' show' : '')}
      ref={nodeRef}
    >
      <a
        aria-haspopup='true'
        href={`#${label.toLowerCase().replace(/\s+/g, '-')}`}
        className='text-white'
        aria-expanded={isOpen ? 'true' : 'false'}
        onClick={toggle}
      >
        {label}
      </a>
      <div
        className={classnames(
          'py-2 flex flex-col z-10 t-full',
          'rounded border bg-white border-gray-900',
          'dark:bg-gray-800 dark:border-gray-100',
          isOpen ? 'block md:absolute' : 'hidden'
        )}
        aria-hidden={isOpen ? 'false' : 'true'}
      >
        {children}
      </div>
    </div>
  );
};

export default NavDropdown;
